
import { LoginForm } from '@ant-design/pro-form';
import { Button, Card, Col, Form, Image, Input, Typography } from 'antd'
import { IErrorResult, IResponse, loginFormType } from 'components/api';
import { useAuth } from 'components/auth';
import React, { useState } from 'react'
import Logo from "assets/images/DahabshiilGreen.png";

const { Text, Link } = Typography;

const Otp = ({
    loginHandler,
    loading,
}: {
    loginHandler: (values: loginFormType) => Promise<IResponse<any>>;
    loading: boolean;
}) => {
    const [state, setState] = useState<{
        isError: boolean;
        error?: IErrorResult;
    }>({
        isError: false,
    });

    const errorsDev = () => {
        const { isError, error } = state;

        if (!isError) {
            return null;
        }
        if (error) {

            return (
                <Text style={{ display: 'flex', justifyContent: 'center' }} type="danger">{
                    error.detail
                }</Text>
            );
        }
    };

    return (
        <Col span={24} style={{ display: "flex", justifyContent: "center", paddingTop: '10%' }}>
            <LoginForm <loginFormType>
                title={<Image src={Logo} alt="Dahabshiil Logo" style={{
                    width: '70%',
                    maxWidth: '200px',
                    margin: '0x auto',
                    paddingBottom: '50px'
                }} />}
                name="otp_form"
                subTitle="Please enter the otp sent to your email address."
                loading={loading}
                onFinish={async (values) => {
                    const { data, isError } = await loginHandler(values);
                    console.log("onfinish", isError);
                    if (isError) {
                        setState({ isError: true, error: data as IErrorResult });
                        return;
                    }
                    //navigate("/otp", { state: values });
                }}
                className="login-form"
                submitter={{
                    render: ({ submit }) => [
                        <Button
                            loading={loading}
                            size="large"
                            type="primary"
                            block
                            onClick={submit}
                        >
                            Verify
                        </Button>,
                    ],
                }}

            >
                <Form.Item
                    name="otp"
                    rules={[
                        {
                            required: true,
                            message: 'Please input your OTP!',
                            len: 6,
                        },
                    ]}
                >
                    <Input placeholder="Enter OTP" />
                </Form.Item>

            </LoginForm>
        </Col>
    )
}

export default Otp
